import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {ShContextMenuComponent} from './sh-context-menu.component';
import {ShAttachMenuDirective} from './sh-attach-menu.directive';
import {ShContextMenuService} from './sh-context-menu.service';
import {ShContextMenuItemDirective} from './sh-context-menu-item.directive';
import {OverlayModule} from '@angular/cdk/overlay';
export class ShContextMenuModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    ShAttachMenuDirective,
    ShContextMenuComponent,
    ShContextMenuItemDirective
  ],
  exports: [
    ShAttachMenuDirective,
    ShContextMenuComponent,
    ShContextMenuItemDirective
  ],
  providers: [
    ShContextMenuService
  ],
  imports: [
    CommonModule,
    OverlayModule
  ],
  entryComponents: [
    ShContextMenuComponent
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ShContextMenuModule_tsickle_Closure_declarations() {
/** @type {?} */
ShContextMenuModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ShContextMenuModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
